import { render, staticRenderFns } from "./before-send.vue?vue&type=template&id=36d728a6&scoped=true"
import script from "./before-send.vue?vue&type=script&lang=js"
export * from "./before-send.vue?vue&type=script&lang=js"
import style0 from "./before-send.vue?vue&type=style&index=0&id=36d728a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d728a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d728a6')) {
      api.createRecord('36d728a6', component.options)
    } else {
      api.reload('36d728a6', component.options)
    }
    module.hot.accept("./before-send.vue?vue&type=template&id=36d728a6&scoped=true", function () {
      api.rerender('36d728a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/before-send.vue"
export default component.exports